import { useEffect, useRef } from "react";
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogHeader,
  DialogTitle,
} from "@/components/ui/dialog";
import { Html5Qrcode } from "html5-qrcode";

// Controle de Estoque — leitor de QR Code via câmera (etiquetas geradas pelo sistema)
export default function QrScanner({ open, onOpenChange, onDecode, title = "Ler QR Code" }) {
  const scannerRef = useRef(null);
  const regionId = useRef(`qr-region-${Math.random().toString(36).slice(2)}`);

  useEffect(() => {
    if (!open) return undefined;
    let stopped = false;
    const t = setTimeout(async () => {
      try {
        const scanner = new Html5Qrcode(regionId.current);
        scannerRef.current = scanner;
        await scanner.start(
          { facingMode: "environment" },
          { fps: 12, qrbox: { width: 250, height: 250 } },
          (text) => {
            if (stopped) return;
            stopped = true;
            onDecode(text);
            onOpenChange(false);
          },
          () => {}
        );
      } catch (err) {
        console.error("QR scanner failed", err);
      }
    }, 300);
    return () => {
      stopped = true;
      clearTimeout(t);
      const s = scannerRef.current;
      scannerRef.current = null;
      if (s) {
        s.stop().then(() => s.clear()).catch(() => {});
      }
    };
  }, [open]); // eslint-disable-line react-hooks/exhaustive-deps

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="max-w-sm" data-testid="qr-scanner-dialog">
        <DialogHeader>
          <DialogTitle className="font-display">{title}</DialogTitle>
          <DialogDescription className="font-body text-xs">
            Aponte a câmera para o QR Code da etiqueta gerada pelo sistema.
          </DialogDescription>
        </DialogHeader>
        <div
          id={regionId.current}
          className="rounded-lg overflow-hidden bg-stone-950 min-h-[260px]"
          data-testid="qr-scanner-region"
        />
      </DialogContent>
    </Dialog>
  );
}
